import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..'; // 在 store/index.ts 中声明的类型
import { SettleOrder } from '../../service/class/SettleOrder';

// 借助 createSlice 创建 reducer、action
const SettleOrderSlice = createSlice({
    name: 'settleOrder',
    initialState: {
        value: new SettleOrder(),
    },
    reducers: {
        setSettleOrder: (state, action: PayloadAction<SettleOrder>) => {
            state.value = action.payload;
        },
    },
});

// Action Creator 用于执行返回描述如何更新 state 的 Action
export const { setSettleOrder } = SettleOrderSlice.actions;

// Selector，作为 useSelector 读取数据的函数参数
export const settleOrderSelector = (state: RootState) => state.settleOrder.value;

// Reducer，真正执行修改 state 的纯函数
export default SettleOrderSlice.reducer;
